import { GroceriesTable } from 'components/Groceries';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Groceries = () => {
  const permissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions,
  );

  const canView = checkPermission(permissions, {
    permissionName: 'GroceryItems',
    permission: ['view', 'viewAll'],
  });

  return <div>{canView && <GroceriesTable />}</div>;
};
